import { defineMessages } from 'react-intl';

export default defineMessages({
  displayNameEmpty: {
    id: 'confirmation.form.displayName.empty',
    defaultMessage: 'Please enter a name',
    description: '',
  },
  displayNamePlaceholder: {
    id: 'confirmation.form.displayName.placeholder',
    defaultMessage: 'Enter full name',
    description: '',
  },
  displayNameLabel: {
    id: 'confirmation.form.displayName.label',
    defaultMessage: 'Full name',
    description: '',
  },
  codePlaceHolder: {
    id: 'confirmation.form.code.placeholder',
    defaultMessage: 'Enter the code sent to your email',
    description: 'Placeholder for text input',
  },
  codeLabel: {
    id: 'confirmation.form.code.label',
    defaultMessage: 'Verification code',
    description: 'Label for text input',
  },
  emailLabel: {
    id: 'confirmation.form.emailaddress.label',
    defaultMessage: 'Email address',
    description: '',
  },
  hiddenEmailWarningTitle: {
    id: 'confirmation.form.hiddenemailwarning.title',
    defaultMessage: "You're hiding your real email",
    description: '',
  },
});
